(function () {
  var STORAGE_KEY = 'astronomyClassifiedsMenuVariant';
  var BASE_PATH = '/pages/petites-annonces';
  var variants = [
    { id: 'petites_annonces', title: 'Petites annonces' },
    { id: 'vendre_mon_telescope', title: 'Vendre mon télescope' },
    { id: 'annonces_gratuites', title: 'Annonces gratuites' },
    { id: 'materiel_occasion', title: 'Matériel d’occasion' },
    { id: 'astro_occasion', title: 'Astro occasion' }
  ];

  var isHomePage = document.body && document.body.classList.contains('template-index');

  var getStoredVariant = function () {
    try {
      var storedId = window.localStorage.getItem(STORAGE_KEY);
      return variants.find(function (variant) { return variant.id === storedId; }) || null;
    } catch (error) {
      return null;
    }
  };

  var storeVariant = function (variant) {
    try {
      window.localStorage.setItem(STORAGE_KEY, variant.id);
    } catch (error) {}
  };

  var pickVariant = function () {
    var stored = getStoredVariant();
    if (stored) return stored;
    if (!isHomePage) return variants[0];
    return variants[Math.floor(Math.random() * variants.length)];
  };

  var hrefForVariant = function (variant) {
    var url = new URL(BASE_PATH, window.location.origin);
    url.searchParams.set('utm_source', 'homepage_menu');
    url.searchParams.set('utm_medium', 'ab_test');
    url.searchParams.set('utm_campaign', 'classifieds_menu_title');
    url.searchParams.set('utm_content', variant.id);
    return url.pathname + url.search;
  };

  var applyVariant = function () {
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-classifieds-ab-link]'));
    if (!links.length) return;

    var variant = pickVariant();
    links.forEach(function (link) {
      var label = link.querySelector('span') || link.querySelector('.menu-with-images > div:last-child') || link;
      var textNode = Array.prototype.slice.call(label.childNodes).find(function (node) {
        return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
      });
      if (textNode) textNode.textContent = variant.title;
      else label.textContent = variant.title;
      link.href = hrefForVariant(variant);
      link.dataset.classifiedsAbVariant = variant.id;
      link.addEventListener('click', function () {
        storeVariant(variant);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyVariant);
  } else {
    applyVariant();
  }
})();
